import React from "react";
import { Button, Table } from "antd";
import { BackendStatusBadge, InfringementTypeBadge, ReviewStatusBadge } from "./status_badges.component";
import { formatDateTime, formatDurationSeconds, formatSpeed } from "../services/firestoreTracking.service";

export const InfringementTable = ({ records, loading, onSelect, pagination = { pageSize: 8 } }) => {
  return <Table
    loading={loading}
    rowKey={(record) => record?.id}
    pagination={pagination}
    dataSource={records}
    scroll={{ x: 1100 }}
    locale={{ emptyText: "No infringements in the live feed." }}
    columns={[
      {
        title: "Type",
        dataIndex: "type",
        render: (_, record) => <InfringementTypeBadge type={record?.type} />,
      },
      {
        title: "Trip",
        render: (_, record) => record?.tripReference || `MYC#${record?.tripOrderId || "Unknown"}`,
      },
      {
        title: "Driver",
        render: (_, record) => record?.driverName || record?.driverIdentifier || "Not available",
      },
      {
        title: "Vehicle",
        render: (_, record) => record?.vehicleRegistration || record?.vehicleLabel || "Not available",
      },
      {
        title: "When",
        dataIndex: "eventAt",
        render: (value) => formatDateTime(value),
      },
      {
        title: "Evidence",
        render: (_, record) =>
          record?.type === "speeding"
            ? `${formatSpeed(record?.actualSpeedKph)} / ${formatSpeed(record?.speedLimitKph)}`
            : formatDurationSeconds(record?.offlineDurationSeconds || record?.telemetryGapSeconds),
      },
      {
        title: "Backend",
        dataIndex: "status",
        render: (value) => <BackendStatusBadge status={value} />,
      },
      {
        title: "Review",
        dataIndex: "reviewStatus",
        render: (value) => <ReviewStatusBadge status={value} />,
      },
      {
        title: "Action",
        dataIndex: "actionStatus",
        render: (value) => value === "logged" ? "Logged" : "Needs action",
      },
      {
        title: "Confidence",
        dataIndex: "confidenceValue",
        render: (value) => (Number.isFinite(Number(value)) ? Number(value).toFixed(2) : "Not available"),
      },
      {
        title: "",
        render: (_, record) => <Button onClick={() => onSelect?.(record)}>Review</Button>,
      },
    ]}
  />;
};
